<template>
  <div>
    <el-row style="display: flex;margin-bottom: 10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
          clearable placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>
      <el-col>
        <el-button v-if="addCaseRecommendClass" @click="$form('addCaseRecommendClass')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加案例分类
        </el-button>
      </el-col>
    </el-row>
    <div>
      <myform :viewobj='{
        addCaseRecommendClass: ["新增案例分类", "el-icon-circle-plus"],
        updateCaseRecommendClass: ["修改案例分类", "el-icon-edit-outline"],
        $succeed$: getCaseRecommendClassList
      }' @confirm='myform' @close='$form("addCaseRecommendClass", "reset")'>
        <template v-slot:crcIcon='{ Myformdata }'>
          <myupload v-event.fileUpload='`
                      return (Myformdata.crcIcon+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.crcIcon = C : false )
                    `' @change='Myformdata.crcIcon = ($file$ = arguments[0]).url'
            @remove='window.sleep(150, v => Myformdata.crcIcon = "")' type='image' :limit='1'
            :params='{ file: "$file$" }' :filelist="Myformdata.crcIcon && Myformdata.crcIcon != ' '
              ? ({ name: Myformdata.crcIcon, url: Myformdata.crcIcon })
              : false" :style="{ height: Myformdata.crcIcon && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
          </myupload>
        </template>

        <hide slot='crcId' />
      </myform>
      <mytable :tableColums='tableColums_getCaseRecommendClassList' api='getCaseRecommendClassList'
        xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
      </mytable>
      <myform :viewobj='{
        updateCaseRecommendClassCopy: ["复制到其他项目", "el-icon-edit-outline"],
        $succeed$: getYcToolsAiBaseList
      }' @closed="$form('updateCaseRecommendClassCopy', 'reset'), window.sleep(50, v => Myformdata && (Myformdata.ytabIcon = ''))
        ">
        <template v-slot:projectId="{ Myformdata }">
          <el-select v-model="Myformdata.projectId" clearable placeholder="请选择项目">
            <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
              :value="item.projectId">
            </el-option>
          </el-select>
        </template>
        <hide slot='crcId' />
      </myform>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: 0,
      value: '',
      form: {
        projectId: '',

      },
      tableColums_getCaseRecommendClassList: {
        $selection: false,

        // oiType: '限制字段key',

        crcName: '案例分类名称',
        //   yvqtcOrder: '排序',


        $operation: [
          '操作', 250,
          this.updateCaseRecommendClassCopy && `@text: 复制到其他项目#primary
                    @click: $form("updateCaseRecommendClassCopy",$row)
            `,
          this.updateCaseRecommendClass && `@text: 编辑#success
               @click: $form("updateCaseRecommendClass",$this.row = $row)
              `,
          this.deleteCaseRecommendClass && `@text: 删除#danger
               @click: _confirm('确定要删除该填写项吗?')
                       .trigger('deleteCaseRecommendClass',{crcId:$row.crcId})
                       .trigger('getCaseRecommendClassList')
              `,
        ],
      }
    }
  },
  methods: {
    async myform(submit, Myformdata) {
      const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))
    },
    async sub(submit) {
      this.$nextTick(() => {

      })
      submit();
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getCaseRecommendClassList({
        ...this.getCaseRecommendClassList_data,
        projectId: this.theProjectId
      })
    },
    getData() {
      this.getCaseRecommendClassList({
        ...this.getCaseRecommendClassList_data,
        projectId: this.theProjectId
      })
    }

  },
  created() {
    this.getCaseRecommendClassList();
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject == 0) {

    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getProjectList({
      pageSize: 0
    });
  },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/ClassificationOfCasess/ClassificationOfCases.vue